import { generateCommonHeader, generateProgressBar } from '.';

export const MP = () => {
  const wrapper = document.getElementById('wrapper');

  Array.from(
    wrapper
      .querySelector('#congrats-header')
      .parentElement.querySelectorAll('[panel-visibility="false"]'),
  ).forEach((e) => e.remove());

  wrapper
    .querySelector('#congrats-header')
    .parentElement.setAttribute('labels', true);

  if (document.querySelector('.top_links')) {
    document.querySelector('.top_links').remove();
  }

  const progress = document.createElement('div'),
    titles = document.createElement('div');

  progress.setAttribute('id', 'progress');
  titles.setAttribute('id', 'titles');
  titles.innerHTML = `<p>Winner Contact Info</p><p>Next Step: FREE OFFERS</p>`;
  progress.append(generateProgressBar(2));
  progress.append(titles);
  wrapper.prepend(progress);
  wrapper.prepend(generateCommonHeader());
};
